import { useEffect } from "react";

const Root = (props) => {
    useEffect(() => {}, []);

    return (
        <div className="alert animated fadeInUp ">
            <div
                className={
                    props.type === "error"
                        ? "alertContainer sunset_background"
                        : props.type === "info"
                        ? "alertContainer indigo_background"
                        : "alertContainer vivere_background"
                }
            >
                <div className="alertText">{props.content}</div>
                <div className="alertAction tap" onClick={props.changeAlert.bind(this, false, "", "")}>
                    Entendido
                </div>
            </div>
        </div>
    );
};

export default Root;
